<template>
  <footer class="footer-area section_gap">
    <CookieBanner/>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-4 single-footer-widget">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a v-on:click="trackFooterClick" href="/contact">Contact Us</a>
            </li>
            <li>
              <a v-on:click="trackFooterClick" href="/faq">Frequently Asked Questions</a>
            </li>
            <li>
              <a v-on:click="trackFooterClick" href="/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/imprint">Imprint</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 single-footer-widget">
          <h4>Contact Address</h4>

          <div class="media contact-info">
            <span class="contact-info__icon">
              <i class="ti-email"></i>
            </span>
            <div class="media-body">
               <p class="text-white">Sanibands Gbr<br/>
              Friedrichstr. 123<br/>
              10117, Berlin, Germany<br/>
              info@sanitizerwristbands.com<br/></p>
              <p>Send us your query anytime!</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 single-footer-widget">
          <h4>We Accept All Cards</h4>

          <div class="media contact-info">
            <img src="../assets/img/paypal-credit-card.png" width="200" alt="Card" />
          </div>
        </div>
      </div>
      <div class="footer-bottom row align-items-center">
        <p class="footer-text m-0 col-lg-8 col-md-12">
          <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
          <Copyright />
          <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
        </p>
        <div class="col-lg-4 col-md-12 footer-social">
          <a href="https://twitter.com/sanitizerbands"><i class="fa fa-twitter"></i></a>
          <!--a href="#"><i class="fa fa-facebook"></i></a>

          <a href="#"><i class="fa fa-dribbble"></i></a>
          <a href="#"><i class="fa fa-behance"></i></a -->
        </div>
      </div>
    </div>
    <modal name="subscribe" ><subscribe @close-modal="close-subscribe-modal"></subscribe></modal>
  </footer>
</template>
<script>
import Copyright from '@/components/Copyright'
import CookieBanner from '@/components/CookieBanner'
import Subscribe from '@/components/Mailchimp'
import {hasSusbcribeCookie} from '@/mixins/storageMixin'
import eventBus from '@/event'

export default {
  components: {
    Copyright,
    CookieBanner,
    Subscribe
  },
  mounted () {
    eventBus.$on('show-subscribe-modal', event => this.showModal())
    eventBus.$on('close-subscribe-modal', event => this.closeModal())
  },
  methods: {
    trackFooterClick (e) {
      window.analytics.track('Clicked from Footer', {
        destination: e.target.innerText
      })
    },
    showModal () {
      const subscribed = hasSusbcribeCookie()
      if (!subscribed) this.$modal.show('subscribe')
    },
    closeModal (event) {
      this.$modal.hide('subscribe')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue